import type { AssignedResourcesTranslationMessages } from './assignedResourcesTranslationMessages';

export const assignedResourcesLanguageFrench: AssignedResourcesTranslationMessages = {
  assigned_lcrs: {
    name: 'LCR',
    fields: {
      id: 'ID',
      name: 'Nom',
      description: 'Description',
      labels: 'Labels',
    },
  },
  assigned_sip_profiles: {
    name: 'Profils SIP',
    fields: {
      id: 'ID',
      name: 'Nom',
      description: 'Description',
      labels: 'Labels',
    },
  },
  assigned_carriers: {
    name: 'Tronc SIP',
    fields: {
      id: 'ID',
      name: 'Nom',
      description: 'Description',
      labels: 'Labels',
    },
  },
  assigned_inbound_e164s: {
    name: 'Inbound E164',
    fields: {
      id: 'ID',
      e164_match: 'E164 Match',
      description: 'Description',
      labels: 'Labels',
      callflow: 'Dialplan',
    },
  },
};
